import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import QuizPage from "./pages/QuizPage";
import ShareQuizPage from "./pages/ShareQuizPage";
import OnboardingPage from "./pages/OnboardingPage";
import HomePage from "./pages/HomePage";

import TestAvatar from "./pages/tests/TestAvatar";
import PuzzleGame from "./pages/tests/TestPuzzleGame";
import QuizLocalMultiplayerPage from "pages/QuizLocalMultiplayerPage";
import IserbaUniqRoutePage from "pages/IserbaUniqRoutePage";
import ProgressMapEditor from "components/progressMap/ProgressMapEditor";
import FullscreenTest from "pages/tests/FullscreenTest";
import RequestCounter from "components/shared/RequestCounter";

const CACHE_VERSION = '007'; // Change this when you want to invalidate cache

const App = () => {
  if (localStorage.getItem('cache_version') !== CACHE_VERSION) {
    console.log('Cache invalidated');
    localStorage.clear();
    localStorage.setItem('cache_version', CACHE_VERSION);
  }

  useEffect(() => {
    function setRealViewportHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    window.addEventListener('resize', setRealViewportHeight);
    window.addEventListener('orientationchange', setRealViewportHeight);
    setRealViewportHeight(); // call it initially

    return () => {
      window.removeEventListener('resize', setRealViewportHeight);
      window.removeEventListener('orientationchange', setRealViewportHeight);
    }
  }, [])

  return (

    <div
      className="relative flex flex-col w-full overflow-hidden"
      style={{
        height: "calc(var(--vh, 1vh) * 100)",
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      < Toaster />
      {/* <RequestCounter /> */}
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/iserba" element={<IserbaUniqRoutePage />} />
          <Route path="/start/:quizId" element={<OnboardingPage />} />
          <Route path="/play/r/:quizId" element={<QuizLocalMultiplayerPage />} />
          <Route path="/play/:quizId" element={<QuizPage />} />
          <Route path="/share/:quizId" element={<ShareQuizPage />} />

          <Route path="/test-puzzle" element={<PuzzleGame />} />
          <Route path="/test-avatar" element={<TestAvatar />} />
          <Route path="/test-fullscreen" element={<FullscreenTest />} />
          <Route path="/map-editor" element={<ProgressMapEditor />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Router>
    </div >
  );
};

export default App;
